import React from 'react';
import robotImg from '@/assets/robot.png';

const ComingSoon: React.FC<{ title?: string }> = ({ title }) => {
  return (
    <div className="panel-card panel-card--main p-8 text-center flex flex-col items-center justify-center min-h-[50vh]">
      <img src={robotImg} alt="Robot" className="w-40 h-auto mb-6 drop-shadow" />
      <h2 className="text-3xl font-bold text-slate-800 mb-2">Próximamente</h2>
      {title && (
        <p className="text-slate-600">La sección "{title}" estará disponible muy pronto.</p>
      )}
    </div>
  );
};

export default ComingSoon;
